import MuiFormHelperText, {
  FormHelperTextProps,
} from '@mui/material/FormHelperText';
import { FC } from 'react';
import styles from './FormHelperText.module.css';

export const FormHelperText: FC<FormHelperTextProps> = (props) => {
  return <MuiFormHelperText {...props} classes={{ root: styles.root }} />;
};
